export type IconSize = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

export const iconSizeMap: Record<IconSize, string> = {
  xs: "var(--icon-xs)",
  sm: "var(--icon-sm)",
  md: "var(--icon-md)",
  lg: "var(--icon-lg)",
  xl: "var(--icon-xl)",
  xxl: "var(--icon-xxl)",
};
